import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "govuk-!-margin-top-8 govuk-notification-banner",
  role: "region",
  "aria-labelledby": "govuk-notification-banner-title",
  "data-module": "govuk-notification-banner"
}
const _hoisted_2 = { class: "govuk-notification-banner__header" }
const _hoisted_3 = {
  class: "govuk-notification-banner__title",
  id: "govuk-notification-banner-title"
}
const _hoisted_4 = { class: "govuk-notification-banner__content" }
const _hoisted_5 = { class: "govuk-notification-banner__heading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.noticeVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.message), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}